import "./App.css";
import "./AgroyaarStyle.css";

import { Button } from "antd";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Login from "@/feature/login/index";
import { errorBoundary } from "@services/api";
import { ErrorBoundary } from "react-error-boundary";
import { QueryClientProvider } from "@tanstack/react-query";
import { Route, Routes, useNavigate } from "react-router-dom";
import { WaterSourceSectionProvider } from "@/context/waterSourceContext";
import YieldGapReport from "@/components/reports/yield_gap/YieldGapReport";
import SoilResult from "@/components/reports/soil/SoilResult";
import WaterExperiment from "@/components/reports/water/waterExperiment";
import ChillingRequirementReport from "@/components/reports/chilling-requirement/ChillingRequirementReport";
import CultivarRecommendationReport from "@/components/reports/cultivar-recommendation";
import HarvestDateRecommendationReport from "@/components/reports/harvest-date-recommendation/HarvestDateRecommendationReport";
import WeedLessReport from "@/components/reports/weedless/WeedLessReport";
import { ProfileProvider } from "@/context/profileContext";
import SowingDateRecommendationReport from "@/components/reports/sowing-date-recommendation/SowingDateRecommendationReport";
import PlantResult from "@/components/reports/plant/PlantResult";
import SaffronIrrigationReport from "@/components/reports/saffron-irrigation/SaffronIrrigationReport";
import LayoutWrapper from "@/layout/components/LayoutWrapper";
import PaymentResult from "@/features/payment/wallet/presentation/pages/PaymentResult";
import LaboratoryReportViewer from "@/features/reports/presentation/pages/LaboratoryReportViewer";
import VisitReportViewer from "@/features/reports/presentation/pages/VisitReportViewer";
import { queryClient } from "@new-services/lib/queryClient";
import CroppingPattern from "@/features/reports/presentation/pages/CroppingPattern";
import CroppingSuitabilityMultiProduct from "@/features/reports/presentation/pages/CroppingSuitabilityMultiProduct";
import CroppingSuitabilitySingleProduct from "@/features/reports/presentation/pages/CroppingSuitabilitySingleProduct";
import errorImage from "@assets/images/Errorimage.png";

function App() {
  const navigate = useNavigate();

  return (
    <ErrorBoundary
      // traceo={traceoInstance}
      onError={(e) => {
        errorBoundary({
          error: JSON.stringify({ message: e.message, stack: e.stack }),
        });
      }}
      fallback={
        <div className="flex flex-col w-1/2 h-full m-auto">
          <img src={errorImage} alt="" />
          <Button
            onClick={() => {
              navigate("/");
              window.location.reload();
            }}
            className="button-neo px-10 max-lg:px-8 py-1.5 max-lg:py-1 text-xl h-fit !text-[#000] hover:brightness-105 max-lg:text-lg"
          >
            بازگشت
          </Button>
        </div>
      }
    >
      <QueryClientProvider client={queryClient}>
        <ToastContainer limit={2} closeOnClick />
        <ProfileProvider>
          <WaterSourceSectionProvider>
            <main>
              <Routes>
                <Route path="login" element={<Login />} />
                <Route path="payment-result" element={<PaymentResult />} />
                <Route path="/*" element={<LayoutWrapper />} index />
                <Route
                  path="/yield-gaps-reports/:id"
                  element={<YieldGapReport />}
                />
                <Route
                  path="/laboratory-reports/water-result/:id"
                  element={<WaterExperiment />}
                />
                <Route
                  path="/laboratory-reports/soil-result/:id"
                  element={<SoilResult />}
                />
                <Route
                  path="/laboratory-reports/leaf-result/:id"
                  element={<PlantResult />}
                />
                <Route
                  path="/laboratory-reports/:id"
                  element={<LaboratoryReportViewer />}
                />
                <Route
                  path="/chilling-requirement-reports/:id"
                  element={<ChillingRequirementReport />}
                />
                <Route
                  path="cultivar-recommendation-reports/:id"
                  element={<CultivarRecommendationReport />}
                />
                <Route
                  path="/harvest-recommendation-reports/:id"
                  element={<HarvestDateRecommendationReport />}
                />
                <Route
                  path="/weedless-report/:id"
                  element={<WeedLessReport />}
                />
                <Route
                  path="/visit-report/:id"
                  element={<VisitReportViewer />}
                />
                <Route
                  path="/sowing-date-reports/:id"
                  element={<SowingDateRecommendationReport />}
                />
                <Route
                  path="/first-saffron-irrigation-reports/:id"
                  element={<SaffronIrrigationReport />}
                />
                <Route
                  path="/cropping-pattern-reports/:id"
                  element={<CroppingPattern />}
                />
                <Route
                  path="/cropping-suitability-multi-product-reports/:id"
                  element={<CroppingSuitabilityMultiProduct />}
                />
                <Route
                  path="/cropping-suitability-single-product-reports/:id"
                  element={<CroppingSuitabilitySingleProduct />}
                />
              </Routes>
            </main>
          </WaterSourceSectionProvider>
        </ProfileProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
